import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ViewportDetectionService } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import get from 'lodash-es/get';
import { Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[finderCmsMargin]',
    standalone: true,
})
export class CmsMarginDirective implements OnInit, OnDestroy {
    private marginData: any;
    private destroy$ = new Subject<void>();

    @Input()
    set finderCmsMargin(data: any) {
        this.marginData = data;
    }

    constructor(
        private elementRef: ElementRef,
        private viewportDetection: ViewportDetectionService,
    ) {}

    ngOnInit() {
        this.setMargin();

        // Listen for changes
        this.viewportDetection.onViewportResize()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.setMargin();
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private setMargin() {
        // Check that we have a bottomMargin value in the data
        let bottomMargin = get(this.marginData, 'bottomMargin');
        if (!bottomMargin) {
            return;
        }

        // Check viewport
        if (this.viewportDetection.isMobile()) {
            bottomMargin = get(this.marginData, 'bottomMarginMobile');
        }

        // Set the style on the element
        const nativeElement = this.elementRef.nativeElement as HTMLElement;
        nativeElement.style.marginBottom = bottomMargin;
    }
}
